import React from 'react'
import { withTranslation } from 'react-i18next'

import img1 from '../../images/png/home/unlock/image1.png'
import img2 from '../../images/png/home/unlock/image2.png'
import img3 from '../../images/png/home/unlock/image3.png'

const UnlockBlock = ({ t }) => {
    return (
        <div className="home__unlock-block">
            <h3 className="dark">{t('_pages._home._unlock_block.title')}</h3>
            <ul className="list">
                <li className="item">
                    <img src={img1} alt="" />
                    <div className="title">{t('_pages._home._unlock_block._list._1.title')}</div>
                    <p>{t('_pages._home._unlock_block._list._1.article')}</p>
                </li>
                <li className="item">
                    <img src={img2} alt="" />
                    <div className="title">{t('_pages._home._unlock_block._list._2.title')}</div>
                    <p>{t('_pages._home._unlock_block._list._2.article')}</p>
                </li>
                <li className="item">
                    <img src={img3} alt="" />
                    <div className="title">{t('_pages._home._unlock_block._list._3.title')}</div>
                    <p>{t('_pages._home._unlock_block._list._3.article')}</p>
                </li>
            </ul>
            <ul className="cards">
                <li className="card">
                    <div className="profit" style={{ backgroundColor: '#FF5656' }}>
                        {t('_pages._home._unlock_block._cards._1.profit')}
                    </div>
                    <p>{t('_pages._home._unlock_block._cards._1.article')}</p>
                </li>
                <li className="card">
                    <div className="profit" style={{ backgroundColor: '#24BFD8' }}>
                        {t('_pages._home._unlock_block._cards._2.profit')}
                    </div>
                    <p>{t('_pages._home._unlock_block._cards._2.article')}</p>
                </li>
            </ul>
            <ul className="balls">
                <li className="ball ball--1"></li>
                <li className="ball ball--2"></li>
                <li className="ball ball--3"></li>
                <li className="ball ball--4"></li>
                <li className="ball ball--5"></li>
            </ul>
        </div>
    )
}

export default withTranslation('translations')(UnlockBlock)
